<template>
  <div class="admin-content">
    <!--列表-->
    <app-list :filter="listOption.filter" :remote="listOption.remote" :table-head="listOption.tableHead" :table-code="listOption.tableCode" ref="list"></app-list>
  </div>
</template>
<script>
import { getGoodList } from '@/api/admin'
import List from '@/views/admin/common/list'

export default {
  components: { 'app-list': List },
  data() {
    return {
      // 列表配置
      listOption: {
        filter: [
          {
            type: 'input',
            labelName: '商品名',
            key: 'name',
            placeholder: '请输入商品名'
          },
          {
            type: 'button',
            isSearch: true,
            value: '搜索'
          }
        ],
        remote: {
          fetch: getGoodList,
          param: {
            name: null,
            page: {
              index: 1,
              size: 10
            }
          }
        },
        tableHead: [
          {
            name: '封面',
            code: 'imageUrl'
          },
          {
            name: '商品名称',
            code: 'name'
          },
          {
            name: '售价',
            code: 'sellPrice'
          },
          {
            name: '创建时间',
            code: 'createTime'
          },
          {
            name: '操作',
            width: '120',
            buttons: [
              {
                value: '查看',
                link: '/admin/good/detail/',
                code: 'id',
                type: 'text'
              }
            ]
          }
        ]
      }
    }
  }
}
</script>
